import { z } from "zod";
import { uuid } from "./common.js";
export const registerRequest = z.object({
    email: z.string().email().max(254),
    // Length only. Composition rules push people toward "Password1!" and are worse
    // than length; the real defence is bcrypt cost 12 plus rate limiting.
    password: z.string().min(10).max(200),
});
export const loginRequest = z.object({
    email: z.string().email().max(254),
    password: z.string().min(1).max(200),
});
export const publicUser = z.object({
    id: uuid,
    email: z.string().email(),
    createdAt: z.string().datetime(),
});
export const authResponse = z.object({
    user: publicUser,
    accessToken: z.string(),
    /** Seconds until `accessToken` expires. D-10 phase 1 issues 24h tokens. */
    expiresIn: z.number().int().positive(),
});
/** Claims the gateway verifies locally -- it never calls auth-svc on the hot path. */
export const accessTokenClaims = z.object({
    sub: uuid,
    email: z.string().email(),
    iat: z.number().int(),
    exp: z.number().int(),
    jti: z.string(),
});
//# sourceMappingURL=auth.js.map